var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.579,
    height: 33.183,
    viewBox: "0 0 24.579 33.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause",
    transform: "translate(-9.989 -7.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M17.049,7.185a1.318,1.318,0,0,0-.156.015V7.185H11.184a1.2,1.2,0,0,0-1.2,1.2v0h0V39.17h0v0a1.194,1.194,0,0,0,1.2,1.194h5.865a1.194,1.194,0,0,0,1.194-1.194v0h0V8.38a1.2,1.2,0,0,0-1.194-1.2Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M28.884,39.17V8.38a1.2,1.2,0,0,0-1.194-1.2,1.318,1.318,0,0,0-.156.015V7.185H21.825a1.2,1.2,0,0,0-1.2,1.2v0h0V39.17h0v0a1.194,1.194,0,0,0,1.2,1.194h5.864a1.194,1.194,0,0,0,1.194-1.194S28.882,39.171,28.884,39.17Z",
    transform: "translate(5.684 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.a02c0b14483780e53f67c2d51ed880ef.svg";
export { ForwardRef as ReactComponent };